import http from './http'

export function getDashboard() {
  return http.get('/admin/dashboard')
}

export function listUsers(params = {}) {
  return http.get('/admin/users', { params })
}

export function getUser(id) {
  return http.get(`/admin/users/${id}`)
}

export function updateUser(id, payload) {
  return http.put(`/admin/users/${id}`, payload)
}

export function resetUserApiKey(id) {
  return http.post(`/admin/users/${id}/reset-api-key`)
}

export function listPlans() {
  return http.get('/admin/plans')
}

export function createPlan(payload) {
  return http.post('/admin/plans', payload)
}

export function updatePlan(id, payload) {
  return http.put(`/admin/plans/${id}`, payload)
}

export function deactivatePlan(id) {
  return http.delete(`/admin/plans/${id}`)
}

export function listSubscriptions(params = {}) {
  return http.get('/admin/subscriptions', { params })
}

export function cancelSubscription(id) {
  return http.post(`/admin/subscriptions/${id}/cancel`)
}

export function getIntegrations() {
  return http.get('/admin/integrations')
}

export function updateIntegration(provider, payload) {
  return http.put(`/admin/integrations/${provider}`, payload)
}

export function testEmailIntegration(to) {
  return http.post('/admin/integrations/email/test', { to })
}

export function getAppReviewCommentInstructions() {
  return http.get('/admin/app-review/comment-instructions')
}

export function listCanvaImportReports(params = {}) {
  return http.get('/admin/canva-import-reports', { params })
}

export function updateCanvaImportReport(id, payload) {
  return http.patch(`/admin/canva-import-reports/${id}`, payload)
}
